
import { useDataTable } from '../../../hooks/useDataTable';
import { interoperabilityHistoryApi } from '../api/history.api';
export const useHistory = (searchData = []) => {
    const table = useDataTable(interoperabilityHistoryApi);
    const { setDataFilters } = table;
  
  return {
   ...table
  };
};
